import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-58">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-59">
        <img src="https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?q=80&w=2940&auto=format&fit=crop" alt="Muay Thai fighter wrapping hands" className="w-full h-full object-cover object-center opacity-40 grayscale" data-id="element-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/80 to-transparent" data-id="element-61" />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/50 to-transparent" data-id="element-62" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-63">
        <div className="max-w-3xl" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex items-center gap-2 text-red-600 font-display tracking-widest text-xl mb-6" data-id="element-65">
            <MapPin size={20} data-id="element-66" />
            <span data-id="element-67">Dallas, TX • Deep Ellum</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-display text-7xl md:text-8xl lg:text-9xl text-white leading-[0.85] uppercase mb-8" data-id="element-68">
            Master The <br data-id="element-69" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-800" data-id="element-70">
              Eight Limbs
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl md:text-2xl text-zinc-400 mb-10 max-w-2xl font-light" data-id="element-71">
            Authentic Muay Thai for serious athletes. No cardio kickboxing. No
            fluff. Just raw technique, heavy sparring, and fight camp
            conditioning.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-72">
            <Button size="lg" onClick={() => document.getElementById('memberships')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-73">
              Join The Team
            </Button>
            <Button size="lg" variant="outline" onClick={() => document.getElementById('training')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-74">
              View Disciplines
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}